import { apiFetch } from "../../../utils/apiFetch"

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  (typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname)
    ? ["http://localhost", "3000/api"].join(":")
    : "/api")

async function handleResponse(response) {
  const contentType = response.headers.get("content-type") || ""
  const data = contentType.includes("application/json")
    ? await response.json().catch(() => null)
    : await response.text().catch(() => "")

  if (!response.ok) {
    const message =
      typeof data === "string"
        ? data
        : data?.message || "OcurriÃ³ un error al procesar la solicitud"
    throw new Error(message)
  }

  return data
}

export async function getSubscriptionPlans() {
  const response = await apiFetch(`${API_BASE}/subscriptions/plans`)
  return handleResponse(response)
}

export async function getClinicSubscriptionStatus(clinicId) {
  const response = await apiFetch(
    `${API_BASE}/subscriptions/clinic-status?clinicId=${encodeURIComponent(
      clinicId,
    )}`,
  )
  return handleResponse(response)
}

export async function previewSubscriptionChange({
  clinicId,
  planCode,
  billingCycle,
}) {
  const response = await apiFetch(`${API_BASE}/subscriptions/preview-change`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      clinicId,
      planCode,
      billingCycle,
    }),
  })

  return handleResponse(response)
}

export async function changeSubscriptionPlan({
  clinicId,
  planCode,
  billingCycle,
}) {
  const response = await apiFetch(`${API_BASE}/subscriptions/change-plan`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      clinicId,
      planCode,
      billingCycle,
    }),
  })

  return handleResponse(response)
}

export async function applyScheduledSubscriptionChanges() {
  const response = await apiFetch(
    `${API_BASE}/subscriptions/apply-scheduled-changes`,
    {
      method: "POST",
    },
  )

  return handleResponse(response)
}
